module.exports = __webpack_public_path__ + "static/media/sopt20ru.892f9764.pdf";